import React from 'react';
import 'stream-chat-react';
import '@planningcenter/datetime-fmt';
import '../../_virtual/moment.js';
import { useChat } from '../hooks/use_chat.js';
import '../chat_api_context.js';
import '@planningcenter/url';
import '@planningcenter/jolt-client';
import 'stream-chat';
import '@planningcenter/tapestry-react';
import { NewChatViewHeader } from './new_chat_view/header.js';
import { ServicesChatOptions } from './services/services_chat_options.js';

const NewServicesChatView = () => {
    const { navigation } = useChat();
    return (React.createElement(React.Fragment, null,
        React.createElement(NewChatViewHeader, null),
        React.createElement(ServicesChatOptions, { isActive: navigation.isNewServicesChatViewActive })));
};

export { NewServicesChatView };
//# sourceMappingURL=new_services_chat_view.js.map
